module.exports = {"621022100":"环城镇","621022101":"曲子镇","621022102":"甜水镇","621022103":"木钵镇","621022104":"洪德镇","621022105":"合道镇","621022106":"虎洞镇","621022107":"毛井镇","621022108":"樊家川镇","621022109":"车道镇","621022200":"天池乡","621022201":"演武乡","621022204":"八珠乡","621022206":"耿湾乡","621022207":"秦团庄乡","621022208":"山城乡","621022209":"南湫乡","621022210":"罗山川乡","621022212":"小南沟乡","621022215":"芦家湾乡","621022500":"四合原旅游开发办公室"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621022.json
// module id = 2941
// module chunks = 0